import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

import AddToCallListModal from 'components/modals/add_to_call_list_modal';
import { bulkCreate } from 'components/tasks/api';

export default class AddToCallListLink extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array.isRequired,
    callList: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    }),
    currentUser: PropTypes.object.isRequired,
    databaseMembers: PropTypes.array.isRequired,
    label: PropTypes.string,
    selectedContacts: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string,
      type: PropTypes.string
    }))
  };

  static defaultProps = {
    callList: {},
    label: 'Add to Call List',
    selectedContacts: []
  };

  state = {
    showFormModal: false
  };

  acknowledgeSuccess = () => {
    this.setState({ showSuccessModal: false });
  };

  getDefaultAssociatedModels = () => [
    {
      associatedModelId: 1,
      associatedModelType: 'Multiple',
      default: true,
      name: 'Multiple Contacts'
    }
  ];

  handleAdd = (task) => {
    const contacts = this.props.selectedContacts.map(contact => [contact.id, contact.type]);

    bulkCreate(task, contacts).then((result) => {
      this.setState({
        showFormModal: false,
        showSuccessModal: true,
        successMessage: result.message
      });
    });
  }

  handleEndAdd = () => {
    this.setState({ showFormModal: false });
  }

  handleStartAdd = () => {
    this.setState({ showFormModal: true });
  }

  render() {
    const { callList, selectedContacts } = this.props;
    if (!callList || selectedContacts.length === 0) return null;

    return (
      <React.Fragment>
        {this.renderLink()}
        {this.renderModal()}
        {this.renderSuccessModal()}
      </React.Fragment>
    );
  }

  renderLink() {
    const { callList } = this.props;

    return (
      <a
        className="clickable"
        key={callList.id}
        name="add-link"
        role="menuitem"
        onClick={this.handleStartAdd}
      >
        {callList.name}
      </a>
    );
  }

  renderModal() {
    const { availableDatabases, callList, currentUser, databaseMembers, selectedContacts } = this.props;
    const { showFormModal } = this.state;

    return (
      <AddToCallListModal
        availableDatabases={availableDatabases}
        callList={callList}
        currentUser={currentUser}
        databaseMembers={databaseMembers}
        defaultAssociatedModels={this.getDefaultAssociatedModels()}
        selectedContacts={selectedContacts}
        shown={showFormModal}
        onCancel={this.handleEndAdd}
        onSubmit={this.handleAdd}
      />
    );
  }

  renderSuccessModal() {
    const { showSuccessModal, successMessage } = this.state;

    return (
      <Modal name="success-modal" show={showSuccessModal}>
        <Modal.Header>
          <Modal.Title>Add to Call List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p dangerouslySetInnerHTML={{ __html: successMessage }} />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-cancel" type="button" onClick={this.acknowledgeSuccess}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
